import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/PageTitle/PageTitle";
import Button from "../../components/Button/Button";
import Table from "../../components/Table/Table";
import { Grid } from "@mui/material";
import { TableSearch } from "../../components/Table/TableActions";
import { useState } from "react";
import useStyles from "./styles";
import Modal from "../../components/Modal";
import SelectGroup from "../../components/FormComponent/SelectGroup";
import ButtonCount from "../../components/ButtonCount/ButtonCount";
import leavedata from "../../dummy_data/leavemgt.json";
import { Icon } from "@iconify/react";
import Badge from "../../components/Badge/Badge";
import { useNavigate, Link } from "react-router-dom";

const LeaveMgt = () => {
  const classes = useStyles();
  const [modalisopen, setModalIsOpen] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const navigate = useNavigate();
  // const [leave, setLeave] = useState("");
  // const handleChange = (e) => {
  //   setLeave(e.target.value);
  // };
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  // };

  const handleApproveModal = (row) => {
    setApproveModal(true);
    setCurrentRow(row);
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => row?.name
    },
    {
      name: "Title",
      selector: (row) => row?.title
    },
    {
      name: "Leave Type",
      selector: (row) => row?.type
    },
    {
      name: "Contact",
      selector: (row) => row?.contact
    },
    {
      name: "Leave Status",
      center: true,
      cell: (row) => (<Badge status={row?.leave_status} />)
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <Link to={`/leavemgt/${row?.id}`} className="table-action-icon">
            <Icon icon="fluent:eye-16-regular" />
          </Link>
          <button className="table-action-icon" onClick={(() => {
            handleApproveModal(row);
          })}
          >
            <Icon icon="mdi:checkbox-marked-circle-outline" />
          </button>
          <button
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }

  ];

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Leave Management"
            subtitle="See the leave status off your employees and team members."
            button={
              <div className="flex gap-10">
                <Button
                  variant="primary"
                  buttonSize="fluid"
                  color="btndefault"
                  onClick={() => {
                    setModalIsOpen(true);
                  }}
                  buttonName="Add Leave Options"
                />
              </div>
            }
          />
          <div>
            <div className={classes.buttoncountcontainer}>
              <ButtonCount func={() => navigate("/leaveoptions")} title="Leave Options" count={3} />
            </div>
            <Table
              data={leavedata}
              columns={columns}
              subHeader={true}
              subHeaderComponent={
                <TableSearch placeholder="Search here..." />
              }
            />
          </div>
          <Modal
            title="Add New Leave option for your teachers"
            subtitle="Setting leave slots give your employees leave options to choose."
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Leave Type" children={
                      <select>
                        <option value="">---Select Leave Type ---</option>
                        <option>Annual Leave</option>
                        <option>Sick Leave</option>
                        <option>Paternity Leave</option>
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup label="Number of Days" children={
                      <select>
                        <option value="">---Number of Days---</option>
                        <option>5</option>
                        <option>10</option>
                        <option>14</option>
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup label="Who can take Leave" children={
                      <select>

                        <option>Teachers</option>
                        <option>Non Teaching</option>
                        <option>Clerical</option>
                      </select>
                    }
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="primaryoutline"
                    buttonSize="full"
                    color="btnfontprimary"
                    buttonName="Cancel"
                  />
                  <Button
                    type="submit"
                    // onClick={handleSubmit}
                    variant="primary"
                    buttonName="Send Leave Request"
                    buttonSize="full"
                    color="btndefault"
                  />
                </div>
              </>
            }
            isopen={modalisopen}
            closeModal={() => {
              setModalIsOpen(false);
            }}
          />
          <Modal
            title="Approve Leave"
            subtitle={`Approve Leave of ${currentRow?.name}`}
            modalContent={
              <>
              </>
            }
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="success"
                    buttonSize="full"
                    color="btndefault"
                    buttonName="Approve Leave"
                  />
                </div>
              </>
            }
            isopen={approveModal}
            closeModal={() => {
              setApproveModal(false);
            }}
          />
        </>
      }
    />
  );
};

export default LeaveMgt;
